import React from "react";
import { Link } from "react-router-dom";

export const Logo = () => {
  return (
    <div className="flex items-center px-6 mt-5">
      <Link to="/dashboard">
        <div className="flex items-center space-x-2">
          <img
            src="/images/icons/icon_xenorize.svg"
            alt="Platform Logo"
            className="w-full"
          />
        </div>
      </Link>
    </div>
  );
};
